import script from "./TabbarIcons.vue?vue&type=script&setup=true&lang=js"
export * from "./TabbarIcons.vue?vue&type=script&setup=true&lang=js"

import "./TabbarIcons.vue?vue&type=style&index=0&id=08f04a6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f04a6e"]])

export default __exports__